import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineL, LabelM } from '@sorare/core/src/atoms/typography';
import { FOOTBALL_PLAY_RIVALS } from '@sorare/core/src/constants/__generated__/routes';
import { useSafePreviousNavigate } from '@sorare/core/src/hooks/useSafePreviousNavigate';

const Root = styled.div`
  position: relative;
`;

export const NoSeasonEmptyState = () => {
  const previous = useSafePreviousNavigate(FOOTBALL_PLAY_RIVALS);
  return (
    <Root>
      <Vertical gap={0}>
        <HeadlineL>
          <FormattedMessage
            id="NoSeasonEmptyState.title"
            defaultMessage="No Season found"
          />
        </HeadlineL>
        <LabelM>
          <FormattedMessage
            id="NoSeasonEmptyState.content"
            defaultMessage="Come back later"
          />
        </LabelM>
      </Vertical>
      <Button onClick={() => previous()} color="tertiary" size="small">
        <FormattedMessage
          id="NoSeasonEmptyState.cta"
          defaultMessage="Go back"
        />
      </Button>
    </Root>
  );
};
